import { useContext } from 'react'
import { ArticleContext, ArticleContextShape } from './ArticleProvider'

export const useArticleContext = () => {
  const value = useContext<Partial<ArticleContextShape>>(ArticleContext)
  return value
}
